import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectsReducer(state = initialState.projects, action) {

    const mergeInProject = (projects, projectUpdate) => {
        const projectsMinusStaleData = projects.filter(project => project.id !== projectUpdate.id);       
        return projectsMinusStaleData.concat(projectUpdate);
    }

    const deleteProject = (current, id) => {
        return current.filter(project => project.id !== id);
    } 

    const setUpdateRequired = projects => {
        return projects.map(p => {
            return { ...p, requiresUpdate: true };
        });   
    }


    switch (action.type) {
        case types.LOAD_PROJECT_SUCCESS:
        case types.UPDATED_PROJECT_SUCCESS:
            return mergeInProject(state, action.project);
            case types.DELETED_PROJECT:      
            return deleteProject(state, action.id);      
        case types.DELETED_PROJECT_INCOMING:  
        case types.UPDATED_PROJECT_INCOMING:
            return deleteProject(state, action.payload.id);    
        case types.DELETED_USER:
        case types.DELETED_USER_INCOMING:
        case types.UPDATED_USER_INCOMING:
        case types.UPDATED_USER_SUCCESS:
            return setUpdateRequired(state);
        default:
            return state;
    }
}

